import { api } from "@/services";
import { useState } from "react";
import { useIsomorphicLayoutEffect } from "../Custom";
function useRimsContents() {
  const [Response, setResponse] = useState(null);
  const [Error, setError] = useState<string>(null);
  const [Loading, setLoading] = useState<boolean>(true);

  useIsomorphicLayoutEffect(() => {
    const Controller = new AbortController();

    const MakeRequest = async () => {
      try {
        const resp = await api.get(`Contents/GetBySlug?slugs=menu-aros-linglong`, {
          signal: Controller.signal
        });
        if (resp.data) {
          setResponse(resp.data);
        } else {
          setError("Nenhum conteúdo encontrado");
        }
      } catch (Err) {
        setError(Err.message);
      } finally {
        setLoading(false);
      }
    };

    MakeRequest();

    return () => Controller.abort();
  }, []);

  return [Response, Error, Loading];
}

export { useRimsContents };
